import module from 'kendu/legacy/module'
import template from './template.html'
import { element } from 'angular'
import './style.scss'

export class comboboxMenuController {
  constructor ($document, $element, $scope, $timeout, $window) {
    this.document = $document
    this.element = $element
    this.isOpen = false
    this.scope = $scope
    this.timeout = $timeout
    this.window = element($window)
    this.combobox = undefined
    this.selectMultiple = false
    this.onKeypress = this.onKeypress.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
    this.onResize = this.onResize.bind(this)
  }

  $onInit () {
    this.document.on('keydown', this.onKeypress)
    this.document.on('click', this.closeMenu)

    this.window.on('scroll', this.closeMenu)
    this.window.on('resize', this.onResize)

    if (this.selectMultiple) this.element.on('click', (event) => (event.stopPropagation()))

    this.combobox.filterOptions()
    this.isOpen = true

    this.timeout(() => {
      this.onResize()
      this.scrollSelected()
    })
  }

  $onDestroy () {
    this.document.off('keydown', this.onKeypress)
    this.document.off('click', this.closeMenu)
    this.window.off('scroll', this.closeMenu)
    this.window.off('resize', this.onResize)
  }

  closeMenu () {
    if (!this.isOpen) return

    this.isOpen = false
    this.element.remove()
    this.combobox.toggleMenu(false)
    this.combobox.setView()
  }

  onKeypress (event) {
    if (event.which === 27) this.closeMenu()
  }

  onResize () {
    let windowWidth = this.window[0].innerWidth
    let windowHeight = this.window[0].innerHeight
    let box = this.combobox.element[0].getBoundingClientRect()
    let alignTop = (this.element[0].scrollHeight > (windowHeight - box.top)) & (box.bottom > (windowHeight - box.bottom))

    let direction = alignTop ? 'up' : 'down'
    let top = alignTop ? 'auto' : `${box.top}px`
    let bottom = alignTop ? `${windowHeight - box.bottom}px` : 'auto'
    let left = `${box.left}px`
    let minWidth = `${box.width}px`
    let maxWidth = `${windowWidth - box.left}px`
    let maxHeight = alignTop ? `${box.top + box.height}px` : `${windowHeight - box.top}px`

    this.direction = direction

    this.element.attr('direction', direction)
    this.element.css('top', top)
    this.element.css('bottom', bottom)
    this.element.css('left', left)
    this.element.css('min-width', minWidth)
    this.element.css('max-width', maxWidth)
    this.element.css('max-height', maxHeight)

    this.scope.$digest()
  }

  scrollSelected () {
    let selected = this.element[0].querySelector('combobox-option.active')
    let filter = selected && this.element[0].querySelector('combobox-menu-filter')

    this.element[0].scrollTop = ((selected && selected.offsetTop) || 0) - ((filter && filter.offsetHeight) || 0)
  }
}

module.component('comboboxMenu', {
  controller: comboboxMenuController,
  template: template,
  transclude: true,
  bindings: {
    selectMultiple: '<',
    options: '<',
    combobox: '<',
  },
})



// WEBPACK FOOTER //
// ./src/deprecated/directive/combobox/menu/component.js